// extracted by mini-css-extract-plugin
export var menuIcon = "_ma-0";
export var menuIconInline = "_ma-1";